import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import PageHeader from "../../../../dashboard/components/page-header/PageHeader";
import { useParams } from "react-router-dom";
import moment from "moment";
import { FcFile } from "react-icons/fc";
// @ts-ignore
import renderHTML from "react-render-html";
import {
  Announcement,
  useAnnouncements,
} from "../../../../../contexts/announcement-context/AnnouncementContext";
import firebase from "firebase";
// import { useAppUser } from "../../../../../contexts/user-context/UserContext";

const AnnouncementViewMember = () => {
  const { id } = useParams() as any;
  const { announcements, readAnnouncement } = useAnnouncements();
  const [state, setState] = useState<Announcement>({
    countries: [],
    createdAt: {} as any,
    createdBy: "",
    createdByName: "",
    date: firebase.firestore.Timestamp.now(),
    description: "",
    duration: 0,
    id: "",
    title: "",
    fileURLs: [],
  });

  useEffect(() => {
    const [ann] = announcements.filter((a) => a.id === id);
    console.log("ann", ann);
    if (ann) {
      setState(ann);
    }
  }, [announcements, id]);

  useEffect(() => {
    readAnnouncement(id, (status) => {
      if (status) {
        console.log("read ok");
      } else {
        console.log("read not ok");
      }
    });
  }, [id, readAnnouncement]);

  return (
    <div>
      <PageHeader title="Notice" sidebarOnly showBackButton={true} />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingBottom: "50px",
          color: "#646464",
          fontSize: "18px",
        }}
      >
        <Row className="mt-4">
          <Col xs={12}>
            <h2 className="text-justify" style={{ fontWeight: 800 }}>
              {state?.title}
            </h2>
          </Col>
          <Col xs={7} className="mt-4" style={{ paddingRight: "70px" }}>
            <div className="editor-content">
              {renderHTML(state?.description)}
            </div>
          </Col>
          <Col xs={5} className="mt-3 px-0">
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Announced By :</strong>
                </span>{" "}
                <span>{state.createdByName}</span>
              </label>
            </div>
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Date/Time :</strong>
                </span>
                {moment(new Date(state?.date?.seconds * 1000)).format(
                  "MM/DD/YYYY"
                )}
                <span className="ml-3">
                  {moment(new Date(state?.date?.seconds * 1000)).format(
                    "h:mm A"
                  )}
                </span>
              </label>
            </div>
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Duration :</strong>
                </span>{" "}
                {state?.duration} days
              </label>
            </div>
            {state?.fileURLs?.length !== 0 && (
              <div className="w-75 mt-5">
                <label>
                  <strong>Attachments:</strong>
                </label>
                <div
                  className="small-scroll pl-5 pt-3 pr-3"
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  {state?.fileURLs?.map((fu, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center"
                        style={{ paddingBottom: "30px" }}
                      >
                        <div className="d-flex align-items-center">
                          <div>
                            {" "}
                            <FcFile
                              style={{ fontSize: "40px", marginRight: "20px" }}
                            />
                          </div>
                          <div>
                            <a
                              href={fu.url}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {fu.fileName}
                            </a>
                          </div>
                        </div>
                        <div style={{ width: "18px", flexShrink: 0 }}>
                          <FaEye
                            style={{ color: "#006699", cursor: "pointer" }}
                            onClick={() => {
                              window.open(fu.url);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AnnouncementViewMember;
